export default __webpack_public_path__ + "media/images/boating-ad96793c63fe5affefd72493c1451420.jpg";